"use client";

import { useRef } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";

const sectionVariants = cva("", {
    variants: {
        top: {
            default: "pt-12 md:pt-16 lg:pt-20",
            large: "pt-24 md:pt-40 lg:pt-52",
            none: "",
        },
        bottom: {
            default: "pb-12 md:pb-16 lg:pb-20",
            large: "pb-24 md:pb-40 lg:pb-52",
            none: "",
        },
        background: {
            default: "bg-bg",
            secondary: "bg-secondary",
        },
    },
    defaultVariants: {
        top: "default",
        bottom: "default",
        background: "default",
    },
});

export default function Section({
    id,
    dataComponent,
    className,
    settings,
    preventAnimation,
    children,
    ...props
}: {
    id?: string;
    dataComponent?: string;
    className?: string;
    settings?: any;
    preventAnimation?: boolean;
    children: React.ReactNode;
    props?: any;
}) {
    const element = useRef(null);
    return (
        <section
            id={id}
            data-component={dataComponent}
            className={cn(
                "",
                className,
                sectionVariants({
                    background: settings?.background,
                    top: settings?.padding?.top,
                    bottom: settings?.padding?.bottom,
                })
            )}
            ref={element}
            {...props}
        >
            {preventAnimation != true ? (
                <motion.div
                    className='h-full'
                    initial={{ opacity: preventAnimation ? 1 : 0, y: preventAnimation ? 0 : 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true, amount: 0.2 }}
                >
                    {children}
                </motion.div>
            ) : (
                children
            )}
        </section>
    );
}
